@if (checkAttribute) {
    <fa-icon [icon]="faCheckCircle" [size]="size" [style]="{ color: iconColor ?? 'var(--green)' }" data-testid="check-icon-checked" />
} @else {
    <fa-icon [icon]="faTimes" [size]="size" class="fs-5" [style]="{ color: iconColor ?? 'var(--markdown-preview-red)' }" data-testid="check-icon-unchecked" />
}
&nbsp;
